<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter pa-4 pb-0">
      <v-row class="mb-0">
        <v-col cols="10">
          <GradeClassStudentSelect
            @changed="gradeClassStudentChange"
            :disableGradeSelect="user.role.type === 'teacher'"
            :autoSyncClassByStudent="false"
            :autoSyncGradeByClass="false"
          />
        </v-col>
        <v-col cols="2">
          <div class="buttonSearch ml-6 d-flex justify-end align-end">
            <v-btn class="search-button" height="40" outlined @click="onFilter"> Tìm kiếm </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    GradeClassStudentSelect
  },
  data() {
    return {
      classData: null,
      grade: null,
      student: null
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    gradeClassStudentChange(data) {
      this.grade = data.grade
      this.classData = data.class
      this.student = data.student
    },
    onFilter() {
      const params = {}
      if (this.classData) params.class = this.classData.id
      if (this.grade) params.grade = this.grade.id
      if (this.student) params.student = this.student.id
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .wrap_filter {
    display: block;
  }
  div.buttonSearch {
    padding-top: 24px;
    margin-left: 0px !important;
  }
}
</style>
